const initialState = {
    markernumber: ''
  };
  
  const markerReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'SET_MARKER_NUM':
            return { ...state, markernumber: action.payload };
        default:
            return state;
    }
  };
  
  export default markerReducer;
  